"use client"

import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "../../lib/utils"

const socialButtonVariants = cva(
  "inline-flex min-h-12 w-full items-center justify-center gap-2 rounded-[10px] border border-black px-3.5 py-3 text-sm font-semibold leading-none shadow-[0px_4px_0px_0px_#000000] transition-[transform,opacity,box-shadow] duration-200 hover:-translate-y-px hover:opacity-95 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-black/20 disabled:cursor-not-allowed disabled:opacity-60",
  {
    variants: {
      platform: {
        linkedin: "bg-[#175CD3] text-white",
        instagram: "bg-[#DB2E78] text-white",
        twitter: "bg-black text-white",
        facebook: "bg-[#1877F2] text-white",
        tiktok: "bg-black text-white",
        substack: "bg-[#FE4800] text-white",
        beehiiv: "bg-[#FFC629] text-black",
        medium: "bg-black text-white",
        website: "bg-[#2EB67D] text-white",
        youtube: "bg-[#FF0000] text-white",
      },
    },
    defaultVariants: {
      platform: "linkedin",
    },
  }
)

export interface SocialButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof socialButtonVariants> {
  icon?: React.ReactNode
  label: string
}

function SocialButton({
  className,
  platform,
  icon,
  label,
  ...props
}: SocialButtonProps) {
  return (
    <button
      type="button"
      className={cn(socialButtonVariants({ platform }), className)}
      {...props}
    >
      {icon ? (
        <span className="flex h-5 w-5 shrink-0 items-center justify-center [&_svg]:h-5 [&_svg]:w-5">
          {icon}
        </span>
      ) : null}
      <span className="truncate">{label}</span>
    </button>
  )
}

export { SocialButton, socialButtonVariants }
